import cn from 'classnames';

import Link from '@/components/renderers/Link';

const bulletTextVariant = {
  BLACK: `lg:text-white`,
  DARK_BLUE: `lg:text-zodiac`,
  PINK: `lg:text-rose`,
  default: `lg:text-cornflower`,
};

const bulletBackgroundVariant = {
  BLACK: ``,
  PINK: `bg-faded-rose`,
  DARK_BLUE: ``,
  default: `bg-faded-cornflower`,
};

type Bullet = {
  theme: keyof typeof bulletTextVariant;
  pill: string;
  href: string;
  text: string;
  ctaText: string;
};

const bullet: Bullet = {
  theme: `PINK`,
  pill: `Report`,
  href: `https://graphcms.com/resources/dxp-report-2020?utm_source=banner&utm_medium=crm&utm_campaign=graphcms`,
  text: `Modernizing your business with composable architectures`,
  ctaText: `Download report`,
};

export default function Banner({ className }: { className?: string }) {
  return (
    <div className={cn(`bg-whisper border-b border-primary-100`, className)}>
      <div className="max-w-6xl mx-auto px-4 lg:px-6 py-3 lg:py-4 flex items-center justify-center lg:justify-between">
        <Link
          href={bullet.href}
          className="flex items-center text-haiti font-medium text-xs sm:text-[15px] w-full group"
        >
          <div
            className={cn(
              `hidden lg:inline-block text-xs px-2 leading-[22px] uppercase rounded transition-colors duration-200`,
              bulletTextVariant[bullet.theme],
              bulletBackgroundVariant[bullet.theme],
            )}
          >
            <span>{bullet.pill}</span>
          </div>
          <p className="lg:ml-3 w-full lg:w-auto text-center lg:text-left">
            {bullet.text}
            <span className="hidden lg:inline-block">.&nbsp;</span>
            <span className={cn(`text-haiti`, bulletTextVariant[bullet.theme])}>
              <span className="hidden lg:inline-block">{bullet.ctaText}</span>
              <span className="duration-100 group-hover:translate-x-1 inline-block ml-1 transform transition-transform">
                &#8594;
              </span>
            </span>
          </p>
        </Link>

        <ul className="space-x-7 font-bold text-sm hidden lg:flex items-center">
          <li>
            <Link
              href="/docs"
              className="hover:text-rose transition-colors text-haiti"
            >
              Documentation
            </Link>
          </li>
          <li>
            <a
              className="hover:text-rose transition-colors text-haiti"
              href="https://app.graphcms.com"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              Login
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
